import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

export const Recognition = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  return (
    <Stack gap='20px'>
      <Stack>
        <Typography variant='body6'>
          {dictionary.steps.recognition.info1}
        </Typography>
        <Typography variant='body6'>
          {dictionary.steps.recognition.info2_line1}
        </Typography>
        <Typography variant='body6'>
          {dictionary.steps.recognition.info2_line2}
        </Typography>
      </Stack>
      <Stack>
        <Typography variant='body4'>
          {dictionary.steps.recognition.info3title}
        </Typography>
        <Typography variant='body6'>
          {dictionary.steps.recognition.info3_line1}
        </Typography>
        <Typography variant='body6'>
          {dictionary.steps.recognition.info3_line2}
        </Typography>
        <Typography variant='body6'>
          {dictionary.steps.recognition.info3_line3}
        </Typography>
        <Typography variant='body6'>
          {dictionary.steps.recognition.info3_line4}
        </Typography>
      </Stack>
      <Typography variant='body6'>
        {dictionary.steps.recognition.info4}
      </Typography>
    </Stack>
  );
};
